<div class="no-prod" *ngIf="!env.production && !env.development" title="Let op: testomgeving">
    Let op: testomgeving
</div>
<app-pwa-install-banner></app-pwa-install-banner>
@if (parentUser) {
    <div class="parent-user" (click)="backToParentUser()">
        Je hebt als {{parentUser?.name}} het account van {{user?.name}} overgenomen.
        Klik hier om terug te gaan naar je eigen account.
    </div>
}
<router-outlet></router-outlet>
<app-connectivity-banner></app-connectivity-banner>
